import { Environment } from './environment.model';
import { version } from '../../package.json';
/* Environment used for dynamic environments. Properties are set with
 * with placeholder strings which are replaced by dynamic values during the
 * build
 */

export const environment: Environment = {
  isProd: false,
  isLocal: false,
  assetsHost: 'https://zav-stage.westermann.de',
  apiUrl: 'https://feat-abu-288-metadata-selection-multiple-values.backend.review.zav.westermann.de/api/v2',
  learningSectionPreviewHost: 'https://lernmodule.stage.westermann.de',
  learningSectionPreviewToken: '68e647c8fa2883318365e3921e527dd5',
  name: 'feat-abu-288-metadata-selection-multiple-values',
  sentry: {
    // disabled in feature branches
    dsn: ''
  },
  playerBaseUrl: 'https://player2.zav-stage.westermann.de',
  backendUrl: 'https://backend.stage.zav.westermann.de',
  appVersion: version
};
